export const isClientSide = () => typeof document !== 'undefined';
